import {create} from 'zustand';
import {expenseApi} from '../services/api/expenseApi';

export const useExpenseStore = create((set) => ({
  expenses: [],
  isLoading: false,

  fetchExpenses: async (params = {}) => {
    set({isLoading: true});
    try {
      const response = await expenseApi.list(params);
      set({expenses: response.data.data || []});
    } finally {
      set({isLoading: false});
    }
  },

  createExpense: async (data) => {
    const response = await expenseApi.create(data);
    const newExpense = response.data.data;
    set(state => ({expenses: [newExpense, ...state.expenses]}));
    return newExpense;
  },

  updateExpense: async (id, data) => {
    const response = await expenseApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      expenses: state.expenses.map(e => (e.id === id ? updated : e)),
    }));
    return updated;
  },

  deleteExpense: async (id) => {
    await expenseApi.remove(id);
    set(state => ({
      expenses: state.expenses.filter(e => e.id !== id),
    }));
  },

  searchExpenses: async (data) => {
    set({isLoading: true});
    try {
      const response = await expenseApi.search(data);
      set({expenses: response.data.data || []});
    } finally {
      set({isLoading: false});
    }
  },
}));
